// extracted by mini-css-extract-plugin
module.exports = {"avatar":"index__avatar__2mo5E","blur":"index__blur__2CYgr","image":"index__image__154sL"};